<template>
  <div class="ui-content dashboard user-section user-height">
    <v-card class="mx-auto normal-card autohg">
      <div class="data-table-section" ref="infoBox">
        <v-data-table
          :headers="onlineUser ? headers.filter((x) => x.value !== 'target-year') : headers"
          fixed-header
          :items="items"
          hide-default-header
          hide-default-footer
          class="elevation-2 cust-table"
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onHeaderAction="onHeaderAction"
              :orderBy="orderBy"
              :onSortChange="onSortChange"
            />
          </template>

          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td class="lead-min-120">
                  <span v-if="item.roll_number" class="blue-text">{{ item.roll_number }}</span>
                  <span v-else>{{ item.id }}</span>
                </td>
                <td>{{ item.name }}</td>
                <td class="lead-300">{{ item.email }}</td>
                <td v-if="!onlineUser">{{ (item && item.class_code) ? item.class_code.replaceAll('##', '-') : '' }}</td>
                <td class="text-center">
                  {{ item.center_name }}
                </td>
                <td class="text-center">
                  {{ item.batch_name }}
                </td>
                <td class="check-100">
                  <div class="check-cust">
                    <v-checkbox v-model="item.checked"></v-checkbox>
                  </div>
                </td>
                <td class="blank-80 cp3-edit-delete-icon">
                  <v-tooltip
                    v-if="active === 1"
                    left
                    content-class="cust-tooltip"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        class="pencil-icon"
                        v-on="on"
                        @click="editStudentDialog(item)"
                        >mdi-pencil</v-icon
                      >
                    </template>
                    <!-- <span>Edit Name/Email ID/Target Year</span> -->
                    <span>{{onlineUser ? 'Edit Name/Email ID' : 'Edit Name/Email ID/Target Year'}}</span>
                  </v-tooltip>
                  <!-- this worked   -->
                  <v-tooltip v-else left content-class="cust-tooltip">
                    <template v-slot:activator="{ on }">
                      <v-icon
                        class="delete-icon"
                        v-on="on"
                        @click="onDelete(item)"
                        >mdi-delete</v-icon
                      >
                    </template>
                    <span>Delete Student</span>
                  </v-tooltip>
                </td>

                <td class="text-left">
                  <div @click="resetPassword(item)">
                    <v-icon
                      title="Reset Password"
                      class="cp3-reset-pass reset-student-password"
                      >mdi-lock-reset</v-icon
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div class="footer-btn" v-if="innerWidth<991">
      <div class="footer-right-btn">
        <div class="pull-left">
          <div>
          <Pagination
            :currentPage="currentPage"
            :totalPage="totalPages"
            :onPageChange="onPageChange"
          />
          </div>
        </div>
      </div>
    </div>
    
    <div class="footer-btn">
      <div class="footer-right-btn">
        <div class="pull-left">
          <v-btn
            @click="toggleUserStatus"
            class="right-btn cust-btn"
            color="primary"
            >{{
              active === 1 ? "Deactivated Students" : "Active Students"
            }}</v-btn
          >
        </div>
        <div class="pull-left">
          <!-- <v-btn
            @click="activateDeactivateStudents"
            class="right-btn cust-btn"
            color="primary"
            >{{
              active === 1 ? "Deactivate Selected" : "Activate Selected"
            }}</v-btn
          > -->
        </div>
      </div>
      <div class="footer-left-btn">
         <div class="pull-left">
         <v-btn
            @click="activateDeactivateStudents"
            class="right-btn cust-btn"
            color="primary"
            >{{
              active === 1 ? "Deactivate Selected" : "Activate Selected"
            }}</v-btn
          >
         </div>
        <div class="pull-left">
          <v-btn @click="openPopUp" class="right-btn cust-btn" color="primary"
            >Allocate New Batch</v-btn
          >
        </div>
        
        <div class="pull-right" v-if="innerWidth>991">
          <Pagination
            :currentPage="currentPage"
            :totalPage="totalPages"
            :onPageChange="onPageChange"
          />
        </div>
      </div>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";
export default {
  name: "ManageUsersStudent",
  props: ["updateRouteDetails", "search", "parentRef"],
  data() {
    return {
      alertBoxData: null,
      status: false,
      cComponent: "",
      modalwidth: "50%",
      batches: [],
      centers: [],
      selectedCenterId: [],
      selectedBatch: [],
      loading: false,
      status: false,
      orderBy: {
        field: "name",
        order: "ASC",
      },
      items: [],
      oldData: [],
      selctedUserForEdit: null,
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      active: 1,
      isLoadingFirstTime: true,
      selectedUsers: [],
      onlineUser: false,
      innerWidth:""
    };
  },
  methods: {
    ...mapActions({
      me: "userStore/me",
      getCenters: "centerAndBatchStore/getCentersByUser",
      getBatches: "centerAndBatchStore/getBatches",
      getSelfSignedUpUsers: "userStore/getSelfSignedUpUsers",
      setUserActiveStatus: "userStore/setUserActiveStatus",
      deleteUser: "userStore/deleteUser",
    }),
    onClose(data) {
      this.status = data.status;
      if (data.reload) {
        this.requesGetSelfSignedUpUsers();
      }
      if (data.is_delete) {
        this.onDeleteStudent(this.selctedUserForEdit);
      }
    },
    resetPassword(item) {
      this.cComponent = "components/coordinator/ResetStudentPassword";
      this.modalwidth = "400px";
      this.status = true;
      item.persistent = false;
      this.alertBoxData = item;
    },
    toggleUserStatus() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.active = this.active === 1 ? 0 : 1;
      this.resetCenterBatches();
      this.updateRouteDetails({
        type: "activateStatus",
        data: { active: this.active, page: 1 },
      });
      this.requesGetSelfSignedUpUsers();
    },
    resetPage() {
      this.currentPage = 1;
      this.updateCurrentPageInSession(1);
    },
    resetCenterBatches() {
      this.selectedBatch = [];
      this.selectedCenterId = [];
      this.batches = this.batches.map((x) => {
        x.checked = false;
        return x;
      });
      this.centers = this.centers.map((x) => {
        x.checked = false;
        return x;
      });
    },
    onCenterSelect(centerIds) {
      if (centerIds && centerIds.length) {
        if (!this.isLoadingFirstTime) this.resetPage();
        this.updateRouteDetails({
          type: "centerIds",
          data: { centerIds },
        });
        this.$root.showLoader = true;
        this.getBatches({ center_id: centerIds })
          .then((response) => {
            // this.$root.showLoader = false;
            if (response && response.list && response.list.length) {
              // if (this.selectedBatch) {
              //   let arr = [];
                // this.selectedBatch.map((xx, i) => {
                //   let isExist = false;
                //   response.list.map((x) => {
                //     if (!isExist) {
                //       isExist = xx === x.id;
                //     }
                //   });
                //   if (!isExist) {
                //     arr.push(xx);
                //   }
                // });
                // console.log(arr,'arr');
                // if (arr && arr.length) {
                //   arr.map((xx) => {
                //     this.selectedBatch.splice(
                //       this.selectedBatch.indexOf(xx),
                //       1
                //     );
                //   });
                // }
              // }
              this.selectedBatch = this.selectedBatch.filter(b=> response.list.findIndex(l=>l.id===b) !== -1)
              this.batches = response.list.map((x) => {
                let c = {};
                c.text = x.name;
                c.value = x.id;
                c.checked =
                  this.selectedBatch && this.selectedBatch.indexOf(x.id) !== -1;
                return c;
              });
            } else {
              this.batches = [];
              this.selectedBatch = [];
            }
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      } else {
        this.batches = [];
      }
    },
    requestGetCenters() {
      this.$root.showLoader = true;
      this.getCenters()
        .then((response) => {
          // this.$root.showLoader = false;
          this.centers = response.map((x) => {
            let c = {};
            c.text = x.name;
            c.value = x.id;
            c.checked = this.selectedCenterId.includes(x.id);
            return c;
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    requesGetSelfSignedUpUsers() {
      let reqData = {
        orderBy: this.orderBy,
        role_id: this.roleIds.ST,
        is_approved: 1,
        active: this.active,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
        searchQuery: this.search,
      };
      if (
        this.selectedBatch &&
        this.selectedBatch.length > 0 &&
        this.batches.length != this.selectedBatch.length
      ) {
        reqData.batch_ids = this.selectedBatch;
      }
      if (
        this.selectedCenterId &&
        this.selectedCenterId.length > 0 &&
        this.centers.length != this.selectedCenterId.length
      ) {
        reqData.center_ids = this.selectedCenterId;
      }
      this.$root.showLoader = true;
      this.getSelfSignedUpUsers(reqData)
        .then((response) => {
          this.isLoadedFirstTime = false;
          if (
            response.list.length == 0 &&
            this.currentPage != 1 &&
            !this.$route.query.resetPage
          ) {
            this.onPageChange(1);
            return;
          }
          this.items = response.list.map((u) => {
            u.checked = false;
            return u;
          });
          this.setOldData(this.items);
          this.totalPages = response.pagination.pageCount;
          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onHeaderAction(e) {
      if (e.header && e.header.type === "check") {
        if (e.data) {
          this.items = this.items.map((u) => {
            u.checked = e.data.checked;
            return u;
          });
        }
      } else if (
        e.header &&
        e.header.type === "multidropdown" &&
        e.header.value === "batch_name"
      ) {
        this.selectedBatch = e.data.selectedItems;
      } else if (
        e.header &&
        e.header.type === "multidropdown" &&
        e.header.value === "center_name"
      ) {
        this.selectedCenterId = e.data.selectedItems;
      } else if (e.header && e.header.type === "button") {
        if (this.items && this.items.length) {
          let allUsers = this.items.map((u) => {
            return u.id;
          });
          this.requestUpdateUserActiveStatus(
            allUsers,
            this.active === 1 ? false : true
          );
        }
      }
    },
    onSortChange() {
      this.requesGetSelfSignedUpUsers();
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requesGetSelfSignedUpUsers();
    },
    requestUpdateUserActiveStatus(user_ids, status, index) {
      let reqData = {
        user_ids: user_ids,
        active: status,
        role_id: this.roleIds.ST,
      };
      this.$root.showLoader = true;
      this.setUserActiveStatus(reqData)
        .then((response) => {
          this.me();
          this.onDeleteStudent();
          this.requesGetSelfSignedUpUsers();
          this.parentRef.defaultData();
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    setOldData(data) {
      this.oldData = _.cloneDeep(data);
    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.currentPage = crd.tabDetails[crd.selectedTab].page;
        this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
        this.active = crd.tabDetails[crd.selectedTab].showActivated;
        this.selectedCenterId = crd.tabDetails[crd.selectedTab].centerIds; // load center ids from session
        this.selectedBatch = crd.tabDetails[crd.selectedTab].batchIds; // load batches in session
      }
      this.requestGetCenters();
      if (!this.selectedCenterId || (this.selectedCenterId && !this.selectedCenterId.length)) {
        this.requesGetSelfSignedUpUsers();
      }
    },
    openPopUp() {
      if (this.items && this.items.length) {
        this.selectedUsers = this.items
          .filter((i) => i.checked)
          .map((u) => u.id);
        if (!this.selectedUsers || this.selectedUsers.length < 1) {
          return this.$toasted.error(`Select atleast one user`);
        }
        this.cComponent =
          "components/coordinator/users/BatchAllocation/BatchAllocationPopup";
        this.alertBoxData = {
          centers: this.centers,
          selectedUsers: this.selectedUsers,
        };
        this.status = true;
        this.modalwidth = "400px";
      }
    },
    activateDeactivateStudents() {
      if (this.items && this.items.length) {
        this.selectedUsers = this.items
          .filter((i) => i.checked)
          .map((u) => u.id);
        if (!this.selectedUsers || this.selectedUsers.length < 1) {
          return this.$toasted.error(`Select atleast one user`);
        }

        // if (this.selectedUsers) {
        this.requestUpdateUserActiveStatus(
          this.selectedUsers,
          this.active === 0 ? true : false
        );
        // }
      }
    },
    onDeleteStudent(user) {
      if (user) {
        const reqData = {
          user_id: [user.id],
          role_id: this.roleIds.ST,
        };
        this.$root.showLoader = true;
        this.deleteUser(reqData)
          .then((response) => {
            this.$toasted.success(`Student Deleted Successfully`, {
              icon: "check_circle",
            });
            this.me();
            this.requesGetSelfSignedUpUsers();
            if (this.parentRef &&Object.keys(this.parentRef).length) {       
              this.parentRef.defaultData();
            }
          })
          .catch((err) => {
            console.log(err);
            this.$root.showLoader = false;
          });
      }
    },
    editStudentDialog(user) {
      this.selctedUserForEdit = user;
      this.cComponent = "components/coordinator/users/EditUsers/Editstudent";
      this.alertBoxData = user;
      this.status = true;
      this.modalwidth = "500px";
    },
    onDelete(item) {
      this.modalwidth = "450px";

      this.cComponent =
        "components/coordinator/users/ManageUsers/ConfirmationDialog";
      this.selctedUserForEdit = item;
      this.status = true;
    },
  },
  mounted() {
    this.innerWidth=window.innerWidth;
    this.onlineUser = this.user.institute === constants.ONLINE_INSTITUTE_ID ? true : false;        
    this.defaultData();
  },
  computed: {
    ...mapState("userStore", ["user"]),
    headers() {
      return [
      { text: "Student Id / \n<span style='color: blue!important;'>Roll No.</span>", value: "roll_number" },
        { text: "Name", value: "name" },
        { text: "Email ID", value: "email", hideSort: true },
        { text: "Target Year", value: "target-year", hideSort: true },

        {
          text: "Center",
          value: "center_name",
          type: "multidropdown",
          options: this.centers,
          class: "text-center",
          allText: "All Centers",
        },
        {
          text: "Batch",
          value: "batch_name",
          type: "multidropdown",
          options: this.batches,
          class: "text-center",
          allText: "All Batches",
        },
        {
          text: "All",
          value: "check",
          type: "check",
          class: "check-100",
          checked: this.isAllUserSelected,
        },
        { text: "", value: "", type: "blank", class: "" },
        { text: "", value: "", type: "blank", class: "" },
      ];
    },
    isAllUserSelected() {
      if (this.items && this.items.length) {
        let tmpArry = this.items.filter((x) => x.checked);
        if (tmpArry) {
          return tmpArry.length === this.items.length;
        }
      }
      return false;
    },
  },
  watch: {
    selectedCenterId(val,oldVal) {
      this.updateRouteDetails({
        type: "batchIds",
        data: { centerIds: val },
      }); if (val && val.length !== oldVal.length) {
        this.onCenterSelect(val);
        this.requesGetSelfSignedUpUsers();
      }
    },
    selectedBatch(val,oldVal) {
      if (!this.isLoadingFirstTime) this.resetPage();
      this.updateRouteDetails({
        type: "batchIds",
        data: { batchIds: val },
      });
      if (val && val.length!==oldVal.length) { 
        this.requesGetSelfSignedUpUsers();
      }
    },
    items: {
      deep: true,
      handler(after, before) {
        let changedItem, index;
        after.map((p, idx) => {
          if (p["active"] !== this.oldData[idx]["active"]) {
            changedItem = p;
            index = idx;
          }
        });
        this.setOldData(after);

        if (changedItem) {
          this.requestUpdateUserActiveStatus(
            [changedItem.id],
            changedItem.active ? true : false,
            index
          );
        }
      },
    },
    search() {
      this.requesGetSelfSignedUpUsers();
    },
  },
};
</script>
